import React from "react"
import autobind from "class-autobind"
import AccountBillingDrawerContent from "./AccountBillingDrawerContent"
import * as accountActions from "../../actions/AccountActions"
import * as api from "../../api"
import AccountStore from "../../stores/AccountStore"
interface IProps {
    open: boolean
    handleClose(): void
}
interface IState {
    openDrawer: boolean
}

export default class AccountBillingDrawer extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            openDrawer: false
        }
        autobind(this)
    }

    componentDidMount() {
        const billdingDetailPage = new URLSearchParams(window.location.search).get('billing_details') === "true"
        const accountPaymentMethodTab = new URLSearchParams(window.location.search).get('tabs') === "account_payment_method"
        accountPaymentMethodTab ?
            api.getPaymentMethods(AccountStore.getCurrentAccount().Id).then(() =>
                accountActions.getAccount(AccountStore.getCurrentAccount().Id, () =>
                    this.setState({ openDrawer: true })
                )
            ) :
            this.setState({ openDrawer: billdingDetailPage })
    }

    componentWillReceiveProps(nextProps: IProps) {
        !this.props.open && nextProps.open &&
            setTimeout(() =>
                this.setState({ openDrawer: true }), 10
            )
    }

    handleClose() {
        this.setState({ openDrawer: false }, () =>
            setTimeout(() =>
                this.props.handleClose(), 100
            )
        )
    }

    render() {
        return this.props.open &&
            <AccountBillingDrawerContent
                open={this.state.openDrawer}
                handleClose={this.handleClose}
            />
    }
}
